import { Field } from "@base-ui/react/field";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, font, fontSize, fontWeight, lineHeight, space } from "../tokens.stylex.ts";
export interface FormFieldProps {
  label: ReactNode;
  /** Optional hint under the control. */
  description?: ReactNode;
  /** Error message; marks the field invalid when present. */
  error?: string | null | undefined;
  /** Small text right of the label, e.g. "Optional". */
  aside?: ReactNode;
  name?: string;
  disabled?: boolean;
  children: ReactNode;
}

/**
 * Label + control + description + error, wired for accessibility by Base UI's
 * Field (label `for`, `aria-describedby`, `aria-invalid`). Wrap one control.
 */
export function FormField({
  label,
  description,
  error,
  aside,
  name,
  disabled,
  children
}: FormFieldProps) {
  return <Field.Root name={name} disabled={disabled} invalid={Boolean(error)} className="x78zum5 xdt5ytf xjenv9e xeuugli">
      <div className="x78zum5 x1pha0wt x1qughib x1a62zme">
        <Field.Label className="xket8oi x1219144 x9aqtqa">{label}</Field.Label>
        {aside ? <span className="xxg9qwl xmccgnw xxe3v3u">{aside}</span> : null}
      </div>
      {children}
      {error ? <Field.Error match className="xmccgnw x1xcodwn x9tub0y">
          {error}
        </Field.Error> : description ? <Field.Description className="xmccgnw xxe3v3u x9tub0y">{description}</Field.Description> : null}
    </Field.Root>;
}

/** Use inside a FormField for custom controls that should be labelled by it. */
export const FieldControl = Field.Control;